import CostItem from "./CostItem";
import './CostList.css';

const CostList = (props) => {
   
  if (props.costs.length === 0) {
    return <h2 className="cost-list__fallback">There are no expenses in this year.</h2>
  }
    
    return <ul className="cost-list">
        {props.costs.map((cost) => (
            <CostItem
                key={cost.id} //завжди додавати коли відображаю список елементів
                date={cost.date}
                description={cost.description}
                amount={cost.amount}
            />
        ))};
    </ul>
}

export default CostList;